// extracted by mini-css-extract-plugin
export var btn = "LinkButton-module--btn--0db56";
export var light = "LinkButton-module--light--c47fe";
export var outline = "LinkButton-module--outline--8851d";
export var shadowed = "LinkButton-module--shadowed--7095a";
export var small = "LinkButton-module--small--b70eb";